import {
  PUBLISH_FORM_REQUEST,
  PUBLISH_FORM_SUCCESS,
  PUBLISH_FORM_FAILURE,
} from "../Types";

const initialState = {
  loading: false,
  publishedForm: null,
  error: null,
};

const PublishFormReducer = (state = initialState, action) => {
  switch (action.type) {
    case PUBLISH_FORM_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case PUBLISH_FORM_SUCCESS:
      return {
        ...state,
        loading: false,
        publishedForm: action.payload,
        error: null,
      };

    case PUBLISH_FORM_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;  
  }
};

export default PublishFormReducer; 
